import { Check, ArrowRight } from 'lucide-react';
import { iconFor, slugify, priceText } from './serviceMeta';

export function WebPackageCard({ service, featured, onConsult }) {
  const Icon = iconFor(service.name);
  const slug = slugify(service.name);
  const deposit = (service.base_price / 2).toLocaleString();
  return (
    <div
      className={`nw-card relative p-7 flex flex-col ${featured ? 'border-[#ff00ff] bg-[#1a0a2e]/90' : ''}`}
      data-testid={`web-build-card-${slug}`}
    >
      {featured && (
        <span className="absolute -top-3 left-6 px-3 py-1 bg-[#ff00ff] text-[#0a0a1f] font-tech text-xs uppercase tracking-widest">
          Most popular
        </span>
      )}
      <Icon size={26} strokeWidth={1.5} className={featured ? 'text-[#ff00ff] mb-5' : 'text-[#00f0ff] mb-5'} />
      <h3 className="font-heading text-2xl font-bold text-white mb-1">{service.name}</h3>
      <p className="text-sm text-slate-400 mb-5">{service.description}</p>
      <p className="font-display text-4xl font-extrabold text-white mb-1">{priceText(service)}</p>
      <p className="font-tech text-xs uppercase tracking-wider text-slate-400 mb-6">
        Project price · ${deposit} deposit to start
      </p>
      <ul className="space-y-2.5 mb-8 flex-1">
        {service.features.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-sm text-slate-200">
            <Check size={16} className="text-[#00f0ff] mt-0.5 shrink-0" /> {f}
          </li>
        ))}
      </ul>
      <button
        onClick={() => onConsult(service)}
        className={`nw-btn w-full flex items-center justify-between px-4 py-3 font-tech uppercase tracking-wider text-sm ${
          featured
            ? 'bg-[#ff00ff] text-[#0a0a1f] hover:bg-white'
            : 'border border-[#00f0ff] text-[#00f0ff] hover:bg-[#00f0ff] hover:text-[#0a0a1f]'
        }`}
        data-testid={`btn-request-consultation-${slug}`}
      >
        Request free consultation <ArrowRight size={16} />
      </button>
    </div>
  );
}
